var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #bdc2d4;\n        fill-rule: evenodd;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M170.562,153.623L138.9,169.336c-1.178.629-5.421-.235-5.421-1.65V135.552c0-1.414,4.243-2.357,5.5-1.65l30.249,16.5C170.484,151.108,171.82,152.994,170.562,153.623ZM150.528,36.634A114.867,114.867,0,1,0,265.4,151.5,114.861,114.861,0,0,0,150.528,36.634Zm61.519,130.974a27.563,27.563,0,0,1-27.578,27.577H113.915a27.562,27.562,0,0,1-27.578-27.577V134.766a27.562,27.562,0,0,1,27.578-27.577h70.554a27.563,27.563,0,0,1,27.578,27.577v32.842Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6f0396b5d60f27d912b39a0701b5da92.svg";
export { ForwardRef as ReactComponent };